<template>
  <div class="verify-form-page">
    <div class="verify-form-container">
      <!-- Logo Section -->
      <div class="logo-section" v-if="siteInfo && siteInfo.LogoUrl">
        <img class="logo" :src="siteInfo.LogoUrl" alt="Practice Logo"/>
      </div>

      <!-- Verification Card -->
      <div class="verify-card" v-if="siteInfo">
        <div class="card-header">
          <h1 class="card-title">{{ this.formName || 'Patient Verification' }}</h1>
          <p class="card-subtitle">Please verify your identity to access your form</p>
        </div>

        <div class="card-body">
          <ErrorDisplay/>

          <div class="form-group">
            <label for="dob-input">
              <span class="label-text">Date of Birth</span>
            </label>
            <div class="input-wrapper">
              <i class="la la-calendar input-icon"></i>
              <b-form-input
                id="dob-input"
                v-model="dob"
                :placeholder="siteInfo.DateFormat"
                class="styled-input"
              ></b-form-input>
            </div>
          </div>

          <div class="form-group">
            <label for="initials-input">
              <span class="label-text">Your Initials</span>
              <span class="label-hint">Example: For John Smith, enter JS</span>
            </label>
            <div class="input-wrapper">
              <i class="la la-user input-icon"></i>
              <b-form-input
                id="initials-input"
                v-model="initials"
                placeholder="Enter your initials"
                class="styled-input"
              ></b-form-input>
            </div>
          </div>

          <b-button
            variant="primary"
            class="verify-btn"
            @click="verify"
            :disabled="loading"
          >
            <i v-if="loading" class="fa fa-spinner fa-spin mr-2"></i>
            <i v-else class="la la-check-circle mr-2"></i>
            {{ loading ? 'Verifying...' : 'Verify Identity' }}
          </b-button>
        </div>

        <!-- Office Information Section -->
        <div class="office-info-section" v-if="getSiteDetails()">
          <div class="office-details">
            <span v-html="getSiteDetails()"></span>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div class="loading-state" v-if="!siteInfo">
        <div class="spinner"></div>
        <p>Loading form information...</p>
      </div>
    <PoweredByFooter />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { mapState, mapActions, mapMutations } from 'vuex';
import moment from 'moment-timezone';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import PoweredByFooter from '@/components/PoweredByFooter.vue';
//import mixin from '../../../mixin.js';

export default {
  name: "VerifyForm",
  props: ['formUrlID', 'urlID', 'siteID', 'formName', 'patientLanguage', 'packetNext'],
  components: { ErrorDisplay, PoweredByFooter },
  //mixins: [mixin],

  created() {
    /*
    let isMobile = window.mobileCheck();
    let isMobileAndTablet = window.mobileAndTabletCheck();
    console.log(`mobileCheck: ${isMobile}`);
    console.log(`mobileAndTabletCheck: ${isMobileAndTablet}`);
    */
    this.init();
  },

  mounted() { 
  },

  data() {
    return {
      siteInfo: null,
      dob: '',
      initials: null,
      loading: false
    };
  },
  methods: {
    ...mapActions('forms', ['verifyForm']),
    ...mapActions('teamio', ['getSiteInfo']),

    async init() {      
      if(!this.siteID) {
        alert(`SiteID is missing. Please try again later. referrer: ${encodeURIComponent(document.referrer)}`);
      } else {
        let res = await this.getSiteInfo({siteID: this.siteID});        
        if(res.status === 200) {
          this.siteInfo = res.data[0];
          //console.log('siteInfo', this.siteInfo);
        }
      }
    },

    async verify() {

      if(!this.dob || this.dob === '') {
        this.$toast.error('Please enter your Date of Birth');
        return false;
      }


      if( !(moment(this.dob, this.siteInfo.DateFormat).isValid()))
      {
        this.$toast.error(`Please enter your DOB in the format ${this.siteInfo.DateFormat}`);
        return false;
      }

      if(!this.initials || this.initials === '') {
        this.$toast.error(`Please enter your Initials`);
        return false;
      }

      let payload = {
        dob: this.dob,
        dateFormat: this.siteInfo.DateFormat,
        initials: this.initials,
        formUrlID: this.urlID  // Use the 7-char nanoid for verification, not the UUID
      }

      console.log('payload in verifyform', payload);
      let res;

      this.loading = true;
      try {
        res = await this.verifyForm(payload);
        console.log(`in verifyform`, res);
        if(res) {
          if(res.data.formIDForWeb) {
            localStorage.setItem('formverified', 'true');
            // now from the formUrlID, let's get the right formIDForWeb associated with this patient
            // Build query params — spread the incoming route query first (generic
            // forwarding so e.g. ?txPlan survives the verification hop); the keys
            // set below (lang, packetNext, packetVerified) still win.
            let query = { ...this.$route.query };
            if (this.patientLanguage && this.patientLanguage !== 'en') {
              query.lang = this.patientLanguage;
            }
            // If this is part of a packet, pass the remaining forms chain and mark as verified
            if (this.packetNext) {
              query.packetNext = this.packetNext;
              query.packetVerified = '1';
            }

            this.$router.push({
              name: 'ViewFormWithUrlID',
              params: {
                formUrlID : this.formUrlID,  // Keep the UUID for form data
                urlID: this.urlID            // Pass the nanoid for URL resolution
              },
              query: query
            });
          } else {
            this.$toast.error('Form not found. Please try again');
          }
        }
      } catch(err) {
        console.log(err);
        this.$toast.error(err.message);
      } finally {
        this.loading = false;
      }
    },

    getSiteDetails() {
      let retVal = '';

      if(this.siteInfo) {
        if(this.siteInfo.Name && this.siteInfo.Name.trim() !== '') {
          retVal = `<strong>${this.siteInfo.Name}</strong>`;
        }

        if(this.siteInfo.Address1 && this.siteInfo.Address1.trim() !== '') {
          retVal = retVal + `<br>${this.siteInfo.Address1}`;

          if(this.siteInfo.Address2 && this.siteInfo.Address2.trim() !== '') {
            retVal = retVal + `<br>${this.siteInfo.Address2}`;
          }

          retVal = retVal + `<br>${this.siteInfo.City}, ${this.siteInfo.State} ${this.siteInfo.Zip}`;
        }

        if(this.siteInfo.OfficePhone && this.siteInfo.OfficePhone.trim() !== '') {
          retVal = retVal + `<br><strong>Phone:</strong> ${this.siteInfo.OfficePhone}`;
        }
      }

      return retVal;
    }
  },

  computed: {    
  }
};
</script>

<style scoped>
.verify-form-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: 'Inter', 'Segoe UI', Roboto, -apple-system, BlinkMacSystemFont, sans-serif;
}

.verify-form-container {
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
}

/* Logo Section */
.logo-section {
  text-align: center;
  margin-bottom: 24px;
}

.logo {
  max-width: 200px;
  max-height: 80px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

/* Verification Card */
.verify-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.card-header {
  background: linear-gradient(135deg, #3abf94 0%, #2d9a77 100%);
  padding: 28px 32px;
  text-align: center;
}

.card-title {
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.card-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9375rem;
  margin: 0;
  font-weight: 400;
}

.card-body {
  padding: 32px;
}

/* Form Groups */
.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
}

.label-text {
  font-weight: 600;
  color: #334155;
  font-size: 0.9375rem;
  display: block;
}

.label-hint {
  font-size: 0.8125rem;
  color: #64748b;
  font-weight: 400;
  display: block;
  margin-top: 2px;
}

/* Input Styling */
.input-wrapper {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 1.125rem;
  pointer-events: none;
  z-index: 1;
}

.styled-input {
  width: 100%;
  padding: 12px 14px 12px 44px !important;
  border: 2px solid #e2e8f0 !important;
  border-radius: 10px !important;
  /* 16px, never 1rem (the app root is 14px): iOS Safari zooms in on focus below 16px and the
     zoom survives the SPA hop into the form, which then opens "cut off". */
  font-size: 16px !important;
  color: #334155 !important;
  transition: all 0.2s ease !important;
  background-color: #f8fafc !important;
}

.styled-input:focus {
  border-color: #3abf94 !important;
  box-shadow: 0 0 0 4px rgba(58, 191, 148, 0.1) !important;
  background-color: white !important;
  outline: none !important;
}

.styled-input::placeholder {
  color: #94a3b8;
}

/* Verify Button */
.verify-btn {
  width: 100%;
  padding: 14px 24px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  background: linear-gradient(135deg, #3abf94 0%, #2d9a77 100%) !important;
  border: none !important;
  color: white !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease !important;
  box-shadow: 0 2px 4px rgba(58, 191, 148, 0.3) !important;
  margin-top: 8px;
}

.verify-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(58, 191, 148, 0.4) !important;
}

.verify-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.verify-btn i {
  font-size: 1.125rem;
}

/* Office Info Section */
.office-info-section {
  padding: 20px 32px 24px;
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
}

.office-details {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.7;
  text-align: center;
}

.office-details :deep(strong) {
  color: #334155;
  font-weight: 600;
}

/* Loading State */
.loading-state {
  text-align: center;
  padding: 48px 24px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top-color: #3abf94;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-state p {
  color: #64748b;
  font-size: 0.9375rem;
  margin: 0;
}

/* Responsive Adjustments */
@media (max-width: 480px) {
  .verify-form-page {
    padding: 16px;
  }

  .card-header {
    padding: 24px;
  }

  .card-title {
    font-size: 1.25rem;
  }

  .card-body {
    padding: 24px;
  }

  .office-info-section {
    padding: 16px 24px 20px;
  }
}
</style>